
import { getMyCard, addExchange, addAnswer, checkExchange } from '@/api/chunjie'
import config from '@/config'
import html2canvas from 'html2canvas'
import { getUserAccount } from '@/api/user.js'
import { funcUrlDel } from '@/libs/utils'
import { nowInDateBetwen } from '@/libs/utils'
import Toast from 'vux/src/components/toast/index.vue'
import cookie from 'vux/src/tools/cookie/index.js'
import Qrcode from 'vux/src/components/qrcode/index.vue'
import Countdown from 'vux/src/components/countdown/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import pic1 from '../../assets/chunjie/fokas/pic1.png'
import pic2 from '../../assets/chunjie/fokas/pic2.png'
import pic3 from '../../assets/chunjie/fokas/pic3.png'
import pic4 from '../../assets/chunjie/fokas/pic4.png'
import pic5 from '../../assets/chunjie/fokas/pic5.png'
import pic6 from '../../assets/chunjie/fokas/pic6.png'
import pic7 from '../../assets/chunjie/fokas/pic7.png'
import pic8 from '../../assets/chunjie/fokas/pic8.png'
import pic9 from '../../assets/chunjie/fokas/pic9.png'
import pic10 from '../../assets/chunjie/fokas/pic10.png'
import pic11 from '../../assets/chunjie/fokas/pic11.png'
import pic12 from '../../assets/chunjie/fokas/pic12.png'
import defaultimg from '../../assets/chunjie/fokas/fu.png'
export default {
directives: {
TransferDom
},
components: {
XDialog,
Countdown,
Toast,
Qrcode
},
name: '',
data () {
return {
errorimg: 'this.src="' + require('../../assets/chunjie/icon_user.png') + '"',
defaultimg: defaultimg,
picture: '',
showcard: false,
headimg: '',
username: '',
baseUrl: config.baseUrl,
qrcodeUrl: '',
cardid: '',
fkObj: [],
showfokas: false,

partyid: '1385',
mobile: '',
fudai: false,
fudaistatus: 0,
dati: false,
total: 0,
show: false,
showtoast: false,
countdown: {
time: 45,
value: '发送',
start: false
},
exchangeObj: {},
check_list: [],
temp: -1,
downImgUrl: '',
type: '',
obj: []
}
},
created () {
this.getfokas(this.checkExchangeNow)
this.getinfor()
console.log(window.location.origin)
},
watch: {
},
computed: {
userid () {
return this.$store.state.user.userid
},
accountid () {
return this.$store.state.user.accountid
}
},
methods: {
getinfor () {
getUserAccount({
userid: this.userid
}).then(data => {
this.headimg = data.returnValue.iconimgPATH
this.username = data.returnValue.acctname
})
},
present () {
if (this.picture == '') {
this.$vux.toast.text('请选择一张您要赠送的福卡', 'middle')
return false
}
this.showcard = true
this.share()
},

shareImg () {
html2canvas(this.$refs.imageWrapper, {
width: this.$refs.imageWrapper.clientWidth, // dom 原始宽度
height: this.$refs.imageWrapper.clientHeight,
scrollY: 0,
scrollX: 0
}).then(canvas => {
let dataURL = canvas.toDataURL('image/jpg')
this.downImgUrl = dataURL
})
},
share () {
this.obj = [this.cardid, this.accountid, this.type]
this.qrcodeUrl =
'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
config.appid +
'&redirect_uri=' +
window.location.origin + '/youzheng/wechat/youzheng/chunjie/myfokas' +
'?obj=' + this.obj +
'/&response_type=code&scope=snsapi_base&state=200&connect_redirect=1#wechat_redirect'
console.log('qr', this.qrcodeUrl)
console.log(window.location)
setTimeout(() => {
this.shareImg()
}, 100)
},
choose (item, i) {
console.log(item)
this.showfokas = true
this.temp = i
this.picture = item.pic
this.cardid = item.cardid
this.type = item.type
},
getfokas (fn) {
this.fkObj = [
{ pic: pic1, num: 0 },
{ pic: pic2, num: 0 },
{ pic: pic3, num: 0 },
{ pic: pic4, num: 0 },
{ pic: pic5, num: 0 },
{ pic: pic6, num: 0 },
{ pic: pic7, num: 0 },
{ pic: pic8, num: 0 },
{ pic: pic9, num: 0 },
{ pic: pic10, num: 0 },
{ pic: pic11, num: 0 },
{ pic: pic12, num: 0 }
]
this.total = 0
this.fudai = false
getMyCard({
openid: this.accountid,
partyid: this.partyid
}).then(data => {










data.returnValue.forEach(item => {
this.total++
let n = this.fkObj[item.type - 1].num
this.$set(this.fkObj[item.type - 1], 'num', n + 1)
this.$set(this.fkObj[item.type - 1], 'name', item.typename)
this.$set(this.fkObj[item.type - 1], 'cardid', item.carid)
this.$set(this.fkObj[item.type - 1], 'type', item.type)
})
for (let i = 0; i < 12; i++) {
if (this.fkObj[i].num === 0) {
if (fn) fn()
return
} else if (i === 11) {
this.fudai = true
}
}
if (fn) fn()
}
)
},
















checkExchangeNow () {
checkExchange({
openid: this.accountid,
partyid: this.partyid
}).then(data => {
this.exchangeObj = data.returnValue
if (
this.fudaistatus === 1 &&
this.fudai &&
this.exchangeObj.status === 0
) {
this.showtoast = true
} else {
this.showtoast = false
}
})
}





}
}
